module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appLogin"
  }, [_c('div', {
    staticClass: "login-modal"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请登录")]), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("登录即可处理新美云待办事项。首次登录成功，系统会自动将您的微信账户与新美云绑定。")]), _vm._v(" "), _c('div', {
    staticClass: "login-phone"
  }, [_c('div', {
    staticClass: "phone-left",
    class: _vm.userPhone ? "" : "phone-left-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPhone),
      expression: "userPhone"
    }],
    attrs: {
      "placeholder": "手机号",
      "type": "text",
      "disabled": _vm.switchFlag ? true : false,
      "onkeyup": "this.value=this.value.replace(/[^\\d\\s]/ig,'')",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.userPhone)
    },
    on: {
      "focus": function($event) {
        _vm.userPhoneFocus = true
      },
      "blur": function($event) {
        return _vm.userPhoneBlur('userPhoneFocus')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPhone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userPhone && _vm.userPhoneFocus),
      expression: "userPhone && userPhoneFocus"
    }],
    attrs: {
      "icon": "close"
    },
    on: {
      "click": function($event) {
        _vm.userPhone = ""
      }
    }
  })]), _vm._v(" "), (!_vm.switchFlag) ? _c('div', {
    staticClass: "phone-right",
    class: _vm.phoneCodeFlag ? "" : "code-disabled",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("\n                " + _vm._s(_vm.btnName))]) : _vm._e(), _vm._v(" "), (_vm.switchFlag) ? _c('div', {
    staticClass: "phone-right"
  }, [_vm._v("已发送(" + _vm._s(_vm.countdown) + "s)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "login-code",
    class: _vm.borderNone ? "login-code-border" : ""
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userCode),
      expression: "userCode"
    }],
    attrs: {
      "placeholder": "验证码",
      "type": "text",
      "onkeyup": "this.value=this.value.replace(/\\D/g,'')",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.userCode)
    },
    on: {
      "focus": function($event) {
        _vm.userCodeFocus = true
      },
      "blur": function($event) {
        return _vm.userPhoneBlur('userCodeFocus')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userCode && _vm.userCodeFocus),
      expression: "userCode && userCodeFocus"
    }],
    attrs: {
      "icon": "clear"
    },
    on: {
      "click": function($event) {
        _vm.userCode = ""
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: !_vm.userPhone || !_vm.userCode ? "btn-disabled" : "",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4ba3264"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AppLogin.vue
// module id = 1682
// module chunks = 471